import React, { Component } from 'react';
import { connect } from "react-redux";

import moment from "moment";
import ReactTooltip from 'react-tooltip';
import { constants } from '../../Helpers/Constants';
import { Translation } from 'react-i18next';

class Flags extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var vehicle = this.props.vehicle;
        var vehicle_details = this.props.vehicle_details;
        
        var flags = []
        var electric, just_added, leaving_soon, awd, new_model, hybrid, plug_in_hybrid, major_redesign, winter_tires, prototype;

        for (var i = 0; i < vehicle.flags.length; i++) {
            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.electric) {
                electric = vehicle.flags[i].Value
            }
    
            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.awd) {
                awd = vehicle.flags[i].Value
            }
    
            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.leaving_soon) {
                leaving_soon = vehicle.flags[i].Value
            }
    
            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.just_added) {
                just_added = vehicle.flags[i].Value
            }
    
            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.new_model) {
                new_model = vehicle.flags[i].Value
            }

            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.hybrid) {
                hybrid = vehicle.flags[i].Value
            }

            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.plug_in_hybrid) {
                plug_in_hybrid = vehicle.flags[i].Value
            }

            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.major_redesign) {
                major_redesign = vehicle.flags[i].Value
            }

            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.winter_tires) {
                winter_tires = vehicle.flags[i].Value
            }

            if (vehicle.flags[i].Flag_Type === constants.vehicle_flags.prototype) {
                prototype = vehicle.flags[i].Value
            }
        }
    
        if (just_added || (moment().diff(moment(vehicle.Available_Date, 'YYYY-MM-DD'), 'days') < 60 && just_added === undefined)) {
            flags.push(
                <div key={just_added}>
                    <Translation>
                    {
                        (t) => <img src = "images/eu-badges/Justadded.svg" data-tip={t("Be one of the first to book this vehicle!")}/>
                    }
                        
                    </Translation>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }
    
        if(electric || (vehicle_details.engine_opt[vehicle.Engine] === 'Electric' && electric === undefined) || (vehicle_details.engine_opt[vehicle.Engine] === 'Électrique' &&  electric === undefined)) {
            flags.push(
                <div key={electric}>
                    <img src = "images/eu-badges/Electric.svg" data-tip="Full Battery Electric Vehicle:  This vehicle does not use gas and needs to be plugged in to recharge.  An electric charging station is highly recommended."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }

        if(hybrid || (vehicle_details.engine_opt[vehicle.Engine] === 'Hybrid' && hybrid === undefined) || (vehicle_details.engine_opt[vehicle.Engine] === 'Hybride' && hybrid === undefined)) {
            flags.push(
                <div key={hybrid}>
                    <img src = "images/eu-badges/Hybrid.svg" data-tip="Hybrid:  This vehicle runs on gas and uses an internal battery that is charged by the car.  This vehicle does not plug in."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }

        if(plug_in_hybrid || (vehicle_details.engine_opt[vehicle.Engine] == 'Plug In Hybrid' || vehicle_details.engine_opt[vehicle.Engine] == 'Hybride rechargeable')) {
            flags.push(
                <div key={plug_in_hybrid}>
                    <img src = "images/eu-badges/PlugInHybrid.svg" data-tip="Plug-in Hybrid:  This vehicle runs on gas and battery.  The battery is plugged in to charge.  An electric charging station is recommended."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }
    
        if(awd || (vehicle_details.drive_train_opt[vehicle.Drive_Train] === 'AWD' && awd === undefined) || (vehicle_details.drive_train_opt[vehicle.Drive_Train] === 'Traction intégrale' && awd === undefined)) {
            flags.push(
                <div key={awd}>
                    <img src = "images/eu-badges/AWD.svg" data-tip="This vehicle has an All-Wheel Drive or 4X4 system.  Check the description for more details."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }

        if((leaving_soon) || (moment(vehicle.Retire_Date, 'YYYY-MM-DD').isValid() && moment(vehicle.Retire_Date, 'YYYY-MM-DD').isSameOrBefore(moment().add(7, 'days')))) {
            flags.push(
                <div key={leaving_soon}>
                    <img src = "images/eu-badges/LeavingSoon.svg" data-tip="This vehicle will be retired from the fleet soon.  Book now before it's gone!"/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }
    
        if(new_model || vehicle.Is_New_Model) {
            flags.push(
                <div key={new_model}>
                    <img src = "images/eu-badges/NewModel.svg" data-tip="This is a brand-new model that has not been produced before."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }

        if (winter_tires || (vehicle_details.tires_opt[vehicle.Tires] == 'Winter' || vehicle_details.tires_opt[vehicle.Tires] == 'Hiver')) {
            flags.push(
                <div key={winter_tires}>
                    <img src = "images/eu-badges/Snowtires.svg" data-tip="This vehicle is equipped with winter tires."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }
        

        if (prototype || vehicle.Is_Prototype) {
            flags.push(
                <div key={prototype}>
                    <img src = "images/eu-badges/Prototype.svg" data-tip="This is a prototype vehicle.  Please be aware of limitations on quality and drivability.  The actual production vehicle may differ from this vehicle."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }

        if (major_redesign || vehicle.Is_Redesign) {
            flags.push(
                <div key={major_redesign}>
                    <img src = "images/eu-badges/Redesign.svg" data-tip="This vehicle has had a major redesign and has some significant improvements over the previous model."/>
                    {/* <ReactTooltip effect="solid" place="bottom"/> */}
                </div>
            )
        }

        if (flags.length > 0) {
            return(
                <div className="eu-vehicle-card--new-badges">
                    {flags}
                </div>
            )
        } else {
            return(<></>)
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(Flags)